module.exports={author:"Woosung Sohn",date:"10/31/2019",publishDate:"10/31/2019",highlighted:!1,tags:"",title:"Driving License"};